import {
    BlockSchema,
    checkBlockIsFileBlock,
    InlineContentSchema,
    StyleSchema,
} from "@blocknote/core";
import {
    useBlockNoteEditor,
    useComponentsContext,
    useDictionary,
    useSelectedBlocks,
} from "@blocknote/react";
import { useEffect, useState } from "react";
import { DorasFilePanel } from "./ImagePicker";
import { IconFileImport } from "@tabler/icons-react";
import { IAccountAssets } from "@/types";

export const FileReplaceButton = ({
    assets,
    setAssets,
    account_id,
    brand_id,
}: {
    assets: IAccountAssets[] | undefined;
    setAssets?: (assets: IAccountAssets[]) => void;
    account_id?: string;
    brand_id?: any;
}) => {
    const dict = useDictionary();
    const Components = useComponentsContext()!;

    const editor = useBlockNoteEditor<
        BlockSchema,
        InlineContentSchema,
        StyleSchema
    >();

    const selectedBlocks = useSelectedBlocks(editor);

    const [isOpen, setIsOpen] = useState<boolean>(false);

    useEffect(() => {
        setIsOpen(false);
    }, [selectedBlocks]);

    const block = selectedBlocks.length === 1 ? selectedBlocks[0] : undefined;

    if (
        block === undefined ||
        !checkBlockIsFileBlock(block, editor) ||
        !editor.isEditable
    ) {
        return null;
    }

    return (
        <Components.Generic.Popover.Root opened={isOpen} position={"bottom"}>
            <Components.Generic.Popover.Trigger>
                <Components.FormattingToolbar.Button
                    className={"bn-button"}
                    onClick={() => setIsOpen(!isOpen)}
                    isSelected={isOpen}
                    mainTooltip={
                        dict.formatting_toolbar.file_replace.tooltip[
                            block.type
                        ] ||
                        dict.formatting_toolbar.file_replace.tooltip["file"]
                    }
                    label={
                        dict.formatting_toolbar.file_replace.tooltip[
                            block.type
                        ] ||
                        dict.formatting_toolbar.file_replace.tooltip["file"]
                    }
                    icon={<IconFileImport />}
                />
            </Components.Generic.Popover.Trigger>
            <Components.Generic.Popover.Content
                className={"bn-popover-content bn-panel-popover"}
                variant={"panel-popover"}
            >
                {/* Replaces default file panel with our Uppy one. */}
                <DorasFilePanel
                    props={{
                        block: block,
                    }}
                    assets={assets}
                    setAssets={setAssets}
                    account_id={account_id}
                />
            </Components.Generic.Popover.Content>
        </Components.Generic.Popover.Root>
    );
};
